import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import React, { FC } from 'react'

interface SolutionStatusModelProp {
    isOpen: boolean;
    onClose: () => void;
    onOpen: () => void;
    status: string;
    data: any[]
}

const SolutionStatusModel: FC<SolutionStatusModelProp> = ({ isOpen, onClose, onOpen, status, data }) => {
    return (
        <Dialog onHide={onClose} visible={isOpen} header={`${status} Orders`} draggable={false} resizable={false} style={{ width: "70vw" }}>
            <DataTable
                value={data}
                paginator
                rows={10}
                rowsPerPageOptions={[10, 20, 50]}
                className="architectsTable"
                style={{ border: "1px solid #ccc" }}
            >
                <Column
                    header="Sr. No"
                    body={(_, options) => options.rowIndex + 1}
                />
                <Column field="orderNumber" header="Order Number" />
                <Column field="projectName" header="Project Name" />
                <Column field="userName" header="Sales Head" />
                <Column field="officeName" header="Office Name" />
                <Column field="totalAmount" header="Total Amount" />
                <Column field="awaitingLocationCount" header={`${status} Locations`} />
            </DataTable>
        </Dialog>
    )
}

export default SolutionStatusModel